import { layoutContainer, mobileLayoutContainer, siteContentContainer, siteInnerContent } from './styles';
import { ReactNode } from 'react';
import '../../styles/global.css';
import { motion, useIsPresent, usePresenceData } from 'motion/react';
import { useMediaQuery } from 'usehooks-ts';
import { Footer } from '../Footer';

const Layout = ({children}: {children: ReactNode}) => {
	const isPresent = useIsPresent()
    const isTableOrMobile = useMediaQuery('(max-width: 768px)');
	
	if (isTableOrMobile) return (
		<main css={mobileLayoutContainer}>
			{children}
			<Footer />
		</main>
	) 

	return (
		<motion.div 
			css={layoutContainer}
			// Unique key for each page based on the current path
			initial={{ x: '100%', boxShadow: '0 40px -40px 0 rgba(0, 0, 0, 0.3)', zIndex: 2 }}
			animate={{ x: 0, boxShadow: '0 40px 40px 40px rgba(0, 0, 0, 0.3)', zIndex: 2 }}
			exit={{ x: 0, boxShadow: '0 0 0 0 rgba(0, 0, 0, 0)', transition: {delay: 1}, zIndex: 1 }}
			transition={{ease: 'easeInOut', duration: 0.8}}
		>
			<motion.div
				animate={!isPresent ? { opacity: 1, display: 'block' } : { opacity: 0, display: 'none' }}
				css={{backgroundColor: 'rgba(0,0,0, 0.4)', height: '100vh', width: '100vw', position: 'fixed', zIndex: 1, top: 0, left: 0}}
				transition={{ duration: 0.5 }}
			/>
			<main css={siteContentContainer}>
				{/* <div css={siteInnerContent}> */}
					{children}
				{/* </div> */}
			</main>
		</motion.div>
	);
};

export default Layout;
